import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import BankDetails from './bankAccDetails';
import GeneralInformation from './generalInformation';
import ForeignAssets from './foreignAssets';
import './styles.css';
import DifferentSource from './differentSource';
import TotalIncome from './totalIncome';
import IncomeTaxPassword from './incomeTax';
import TravelledOutsideIndia from './travelledOutside';
import Director from './directorInIndia';
import AdditionalQuestions from './additionalQuestions';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: '0',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    accordContentSummary: {
        background: '#f9f9f9',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
        right: '72px',
        position: 'absolute',
        top: '18px',
    },
    marginTop: {
        marginTop: '9px !important',
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
        ['@media (max-width:600px)']: {
            marginTop: '-15px !important',
        },
    },
}));
// function StyledRadio(props) {
//     const classes = useStyles();

//     return (
//         <Radio
//             className={classes.root}
//             disableRipple
//             color="default"
//             checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
//             icon={<span className={classes.icon} />}
//             {...props}
//         />
//     );
// }
export default function Accordin(props, values) {
    const classes = useStyles();
    // const [selectedValue, setSelectedValue] = React.useState('a');

    const [generalInformation, setGeneralInformationData] = useState([]);

    //console.log('generalInformation', generalInformation);
    const [expanded, setExpanded] = React.useState('');
    const history = useHistory();

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    // const handleChange = (event) => {
    //     setSelectedValue(event.target.value);
    // };

    const navigate = () => {
        //console.log();
        history.push('/menu/addAdditional');
    };

    return (
        <div className={classes.root}>
            <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header" className="padding10">
                    <Typography className={classes.heading}>General Information</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <GeneralInformation generalInformationData={setGeneralInformationData} />
                </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" className="padding10">
                    <Typography className={classes.heading}>Bank Account Details</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <BankDetails />
                </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header" className="padding10">
                    <Typography className={classes.heading}>What are the difference sources of income that you have?</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <DifferentSource />
                </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4a-content" id="panel4a-header" className="padding10">
                    <Typography className={classes.heading}>Income tax login password</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <IncomeTaxPassword />
                </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5a-content" id="panel5a-header" className="padding10">
                    <Typography className={classes.heading}>Have you travelled outside India during the previous year?</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <TravelledOutsideIndia />
                </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel6a-content" id="panel6a-header" className="padding10">
                    <Typography className={classes.heading}>
                        Whether you were director in a company at any time during the previous year?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <Director />
                </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel7a-content" id="panel7a-header" className="padding10">
                    <Typography className={classes.heading}>Do you have income/assets from sources outside India?</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <ForeignAssets />
                </AccordionDetails>
            </Accordion>

            <Accordion square expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel8a-content" id="panel8a-header" className="padding10">
                    <Typography className={classes.heading}>Does your total income exceeds Rs. 50 Lakhs?</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <TotalIncome />
                </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel7a-content" id="panel7a-header" className="padding10">
                    <Typography className={classes.marginTop}>Additional Questions</Typography>
                    <Button variant="outlined" color="primary" size="small" onClick={navigate} className={classes.button}>
                        Add Additional Questions
                    </Button>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <AdditionalQuestions />
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
